import Icon from '../../components/Icon.vue'

Icon.register({"regular/clone":{"width":512,"height":512,"paths":[{"d":"M464 0H144C117.5 0 96 21.5 96 48V96H48C21.5 96 0 117.5 0 144V464C0 490.5 21.5 512 48 512H368C394.5 512 416 490.5 416 464V416H464C490.5 416 512 394.5 512 368V48C512 21.5 490.5 0 464 0zM362 464H54A6-6 0 0 0 48 458V150A6-6 0 0 0 54 144H96V368C96 394.5 117.5 416 144 416H368V458A6-6 0 0 0 362 464zM458 368H150A6-6 0 0 0 144 362V54A6-6 0 0 0 150 48H458A6-6 0 0 0 464 54V362A6-6 0 0 0 458 368z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/clone.js
// module id = gX2x
// module chunks = 0